<template>
	<div class="house">
		<navBar>{{ title }}</navBar>
		<div class="content-box">
			<div class="houseitem df-a" v-for="(item,i) in dataList" :key="i">
				<div class="leftBox">
					<img :src="item.shopimages" alt="">
				</div>
				<div class=" df-d df-sa" style="height: 100%;">
					<p class="font30">{{item.shopname}}</p>
					<p class="font24 mCG">兑换时间：{{item.paytime.substring(0,10)}}</p>
					<p class="font24 mCG">订单号：{{item.orderid}}</p>
				</div>
				<div class="bnt font24 mCc df-mc">
					已兑换
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'houseBox',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '我的礼品屋',
			dataList: []
		};
	},
	created() {
		this.getusershop()
	},
	methods: {
		getusershop() {
			this.$api
				.getusershop({
					navid: this.currentId
				})
				.then((res) => {
					let resData = res.data.data;
					this.dataList = resData;
				});
		},
		goPage(path) {
			this.$router.push({
				path: path,
				query: {
					id: 45,
					name: 'name',
					active: 1
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.house {
	height: calc(100% - 1.08rem);
	padding: 0.34rem 0.28rem 0.28rem 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		.houseitem{
			width: 100%;
			background: #FFFFFF;
			border-radius: 0.1rem;
			padding: 0.28rem;
			position: relative;
			margin-bottom: 0.28rem;
			.leftBox{
				width: 1.6rem;
				height: 1.6rem;
				background-color: #f5faff;
				margin-right: 0.3rem;
			}
			.bnt{
				width: 1.16rem;
				height: 0.45rem;
				background: #FFF9F6;
				border-radius: 0.04rem;
				position: absolute;
				right: 0.28rem;
				top: 50%;
				margin-top: -0.25rem;
			}
		}
	}
}
</style>
